import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionValidityVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
}>;


export type CollectionValidity = { collectionValidation: Array<Pick<Types.Collection_Validation, 'isErc721' | 'hasRoyalties' | 'hasSingleOwner' | 'hasValidMetadata' | 'status' | 'totalTokenCount' | 'data'>>, nftValidation: Array<Pick<Types.Nft_Validation, 'status' | 'tokenId' | 'hasValidMimeType' | 'hasValidMetadata' | 'hasValidAssetSize' | 'hasRoyalties' | 'data'>> };



export const CollectionValidityDocument = /*#__PURE__*/ `
    query CollectionValidity($contractAddress: String!) {
  collectionValidation: collection_validation(
    where: {contractAddress: {_eq: $contractAddress}}
  ) {
    isErc721
    hasRoyalties
    hasSingleOwner
    hasValidMetadata
    status
    totalTokenCount
    data
  }
  nftValidation: nft_validation(where: {contractAddress: {_eq: $contractAddress}}) {
    status
    tokenId
    hasValidMimeType
    hasValidMetadata
    hasValidAssetSize
    hasRoyalties
    data
  }
}
    `;

export const useCollectionValidity = <
      TData = CollectionValidity,
      TError = ClientError
    >(
      variables: CollectionValidityVariables,
      options?: Omit<UseQueryOptions<CollectionValidity, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionValidity, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionValidity, TError, TData>(
      {
    queryKey: ['CollectionValidity', variables],
    queryFn: hasuraFetcher<CollectionValidity, CollectionValidityVariables>(CollectionValidityDocument, variables),
    ...options
  }
    )};

useCollectionValidity.getKey = (variables: CollectionValidityVariables) => ['CollectionValidity', variables];

export const useInfiniteCollectionValidity = <
      TData = InfiniteData<CollectionValidity>,
      TError = ClientError
    >(
      variables: CollectionValidityVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionValidity, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionValidity, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionValidity, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionValidity.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionValidity, CollectionValidityVariables>(CollectionValidityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionValidity.getKey = (variables: CollectionValidityVariables) => ['CollectionValidity.infinite', variables];


useCollectionValidity.fetcher = (variables: CollectionValidityVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionValidity, CollectionValidityVariables>(CollectionValidityDocument, variables, options);
